<template>
    <b-modal id="modal-job-record" size="lg" centered no-close-on-backdrop no-close-on-esc
        :body-class="'px-3 pt-2 overflow-preview-auto'" :footer-class="'d-block border-0 pt-0 pb-3 m-0'"
        :header-class="'align-items-center'" scrollable>
        <template #modal-header="{ close }">
            <h5 class="modal-title">
                {{ jobData ? $t('jobRecord.editTitle') : $t('jobRecord.addTitle') }}
            </h5>
            <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                Close
            </b-button>
        </template>
        <div class="body">
            <b-row>
                <b-col sm="12">
                    <b-form-group :label="$t('jobRecord.jobNameLabel')" class="text-left mb-0">
                        <b-form-input v-model="recordPayload.name" type="text" :placeholder="$t('jobRecord.jobNamePlaceholder')"
                            class="unit f-12" required></b-form-input>
                        <p v-if="errors && errors.name" class="field-error">
                            {{ errors.name[0] }}
                        </p>
                    </b-form-group>
                </b-col>
                <b-col sm="12" class="mt-3">
                    <b-form-group :label="$t('jobRecord.companyNameLabel')" class="text-left mb-0">
                        <b-form-input v-model="recordPayload.company_name" type="text" :placeholder="$t('jobRecord.companyNamePlaceholder')"
                            class="unit f-12" required></b-form-input>
                        <p v-if="errors && errors.company_name" class="field-error">
                            {{ errors.company_name[0] }}
                        </p>
                    </b-form-group>
                </b-col>
                <b-col sm="12" class="mt-3">
                    <b-form-group :label="$t('jobRecord.companyAddressLabel')" class="text-left mb-0">
                        <b-form-input v-model="recordPayload.company_address" type="text"
                            :placeholder="$t('jobRecord.companyAddressPlaceholder')" class="unit f-12" required></b-form-input>
                        <p v-if="errors && errors.company_address" class="field-error">
                            {{ errors.company_address[0] }}
                        </p>
                    </b-form-group>
                </b-col>
                <b-col sm="12" class="mt-3">
                    <b-form-group :label="$t('jobRecord.companyPhoneLabel')" class="text-left position-relative mb-2">
                        <b-input-group size="lg" class="w-100 f-12" prepend="+1">
                            <b-form-input v-mask="phoneMask" v-model="recordPayload.company_phone"
                                :placeholder="$t('jobRecord.companyPhonePlaceholder')"></b-form-input>
                        </b-input-group>
                        <p v-if="errors && errors.company_phone" class="field-error mt-2">
                            {{ errors.company_phone[0] }}
                        </p>
                    </b-form-group>
                </b-col>
                <b-col sm="12" class="mt-3">
                    <div class="text-left">
                        <label class="state">{{ $t('jobRecord.appTypeLabel') }}</label>
                        <b-form-select class="f-12" :options="appTypeOptions" v-model="recordPayload.app_type">
                        </b-form-select>
                        <p v-if="errors && errors.app_type" class="field-error mt-2">
                            {{ errors.app_type[0] }}
                        </p>
                    </div>
                </b-col>
                <b-col sm="12" class="mt-3">
                    <div class="text-left">
                        <label class="state">{{ $t('jobRecord.employerRequiredLabel') }}</label>
                        <b-form-select class="f-12" :options="employerRequiredOptions" v-model="recordPayload.employer_required">
                        </b-form-select>
                        <p v-if="errors && errors.employer_required" class="field-error mt-2">
                            {{ errors.employer_required[0] }}
                        </p>
                    </div>
                </b-col>
                <b-col sm="12" class="mt-3">
                    <b-form-group :label="$t('jobRecord.requirementsLabel')" class="text-left mb-0">
                        <vue-editor class="job-markdown-editor" v-model="recordPayload.requirements"
                            :editor-toolbar="customToolbar" />
                        <p v-if="errors && errors.requirements" class="field-error mt-2">
                            {{ errors.requirements[0] }}
                        </p>
                    </b-form-group>
                </b-col>
                <b-col sm="12" class="mt-3" v-if="jobData">
                    <b-form-group :label="$t('jobRecord.jobUrlLabel')" label-for="check-user" class="text-left label position-relative">
                        <b-form-textarea rows="1" disabled style="padding-right: 10%;" class="resize-none f-12"
                            v-model="jobLink"></b-form-textarea>
                        <svg @click="copyURL(jobLink)" class="copy-referrral-link cursor-pointer" width="15" height="15"
                            viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9.84375 10.7813V12.8906C9.84375 13.2788 9.52875 13.5938 9.14062 13.5938H3.04688C2.86039 13.5938 2.68155 13.5197 2.54969 13.3878C2.41783 13.2559 2.34375 13.0771 2.34375 12.8906V4.92188C2.34375 4.53375 2.65875 4.21875 3.04688 4.21875H4.21875C4.53286 4.21854 4.84644 4.24446 5.15625 4.29625M9.84375 10.7813H11.9531C12.3412 10.7813 12.6562 10.4663 12.6562 10.0781V7.03125C12.6562 4.24375 10.6294 1.93063 7.96875 1.48375C7.65894 1.43196 7.34536 1.40604 7.03125 1.40625H5.85938C5.47125 1.40625 5.15625 1.72125 5.15625 2.10938V4.29625M9.84375 10.7813H5.85938C5.67289 10.7813 5.49405 10.7072 5.36219 10.5753C5.23033 10.4434 5.15625 10.2646 5.15625 10.0781V4.29625M12.6562 8.4375V7.26563C12.6562 6.70619 12.434 6.16966 12.0384 5.77407C11.6428 5.37849 11.1063 5.15625 10.5469 5.15625H9.60938C9.42289 5.15625 9.24405 5.08217 9.11219 4.95031C8.98033 4.81845 8.90625 4.63961 8.90625 4.45313V3.51563C8.90625 3.23862 8.85169 2.96432 8.74568 2.7084C8.63968 2.45248 8.4843 2.21995 8.28843 2.02407C8.09255 1.8282 7.86002 1.67282 7.6041 1.56682C7.34818 1.46081 7.07388 1.40625 6.79688 1.40625H6.09375"
                                stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                    </b-form-group>
                </b-col>
            </b-row>

        </div>
        <template #modal-footer="">
            <div class="text-right modal-footer border-0 p-0 mt-3 mx-0">
                <b-button class="mx-0 h-40px w-100px mr-3 m-0" block @click="resetFilterFields">{{ $t('jobRecord.close') }}</b-button>
                <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary" @click="sendJobData()">{{ $t('jobRecord.save') }}</b-button>
            </div>
        </template>
    </b-modal>
</template>
<script>
import { mapActions } from 'vuex';
import "vue-select/dist/vue-select.css";
import { VueEditor } from "vue2-editor";
export default {
    name: "JobRecord",
    props: ['jobData'],
    components: {
        VueEditor
    },
    data() {
        return {
            recordPayload: {
                name: "",
                company_name: "",
                company_address: "",
                company_phone: "",
                requirements: "",
                employer_required: "",
                app_type: ""
            },
            customToolbar: [
                // Text style
                ["bold", "italic", "underline", "strike"],

                // Headers and fonts
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                [{ font: [] }],
                [{ size: ["small", false, "large", "huge"] }],

                // Lists
                [{ list: "ordered" }, { list: "bullet" }],

                // Alignment
                [{ align: [] }],

                // Colors
                [{ color: [] }, { background: [] }],

                // Links, images, etc.
                ["link", "image"],

                // Clear formatting
                ["clean"]
            ],
            jobLink: "",
            errors: {}
        };
    },
    computed: {
        appTypeOptions() {
            return [
                { text: '-', value: '' },
                { text: this.$t('jobRecord.appTypeFullDot'), value: 'Full DOT' },
                { text: this.$t('jobRecord.appTypeNonDot'), value: 'Non DOT' },
            ];
        },
        employerRequiredOptions() {
            return [
                { text: '-', value: '' },
                { text: this.$t('jobRecord.employerNo'), value: 'No' },
                { text: this.$t('jobRecord.employerAny'), value: 'Any' },
                { text: '2 YR', value: '2 YR' },
                { text: '3 YR', value: '3 YR' },
                { text: '10 YR', value: '10 YR' },
            ];
        },
        phoneMask() {
            return this.recordPayload.company_phone?.length > 0
                ? [
                    /\d/, /\d/, /\d/, " ",
                    /\d/, /\d/, /\d/, " ",
                    /\d/, /\d/, /\d/, /\d/
                ]
                : false; // Allows empty input
        }
    },
    watch: {
        jobData: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.recordPayload = {
                        name: newVal.name || "",
                        company_name: newVal.company_name || "",
                        company_address: newVal.company_address || "",
                        company_phone: newVal.company_phone || "",
                        requirements: newVal.requirements || "",
                        employer_required: newVal.employer_required || "",
                        app_type: newVal.app_type || ""
                    };
                    this.jobLink = newVal.job_link || "";
                }
            }
        }
    },
    methods: {
        ...mapActions(['setNotification', 'addJobData', 'setLoader', 'updateJobData']),
        async copyURL(url) {
            if (url) {
                try {
                    await navigator.clipboard.writeText(url);
                    await this.setNotification({
                        msg: this.$t('jobRecord.jobLinkCopied'),
                        type: "success",
                        color: "green",
                    });
                } catch (e) {
                    console.log(e)
                }
            }
        },
        resetFilterFields() {
            this.recordPayload = {
                name: "",
                company_name: "",
                company_address: "",
                company_phone: "",
                requirements: "",
                employer_required: "",
                app_type: ""
            };
            this.jobLink = "";
            this.errors = {};
            this.$emit("updateJobData", null);
            this.$bvModal.hide('modal-job-record');
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async sendJobData() {
            try {
                const nullKeys = this.checkNullValues({
                    name: this.recordPayload.name,
                    company_name: this.recordPayload.company_name,
                    company_address: this.recordPayload.company_address,
                    company_phone: this.recordPayload.company_phone,
                    employer_required: this.recordPayload.employer_required,
                    app_type: this.recordPayload.app_type
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true);
                    if (this.jobData && this.jobData.id) {
                        this.recordPayload.id = this.jobData.id;
                        await this.updateJobData(this.recordPayload);
                    }
                    else await this.addJobData(this.recordPayload);
                    await this.setNotification({
                        msg: (this.jobData && this.jobData.id) ? this.$t('jobRecord.jobUpdated') : this.$t('jobRecord.jobAdded'),
                        type: "success",
                        color: "green",
                    });
                    this.resetFilterFields();
                    this.setLoader(false);
                    this.$emit("refreshJobs")
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('jobRecord.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
                this.setLoader(false)
            }
        },
    },
};
</script>
<style>
.job-markdown-editor .ql-toolbar.ql-snow {
    border: 1px solid #e3e3e3;
    border-bottom: none !important;
    border-radius: 5px 5px 0 0 !important;
}

.job-markdown-editor .ql-container.ql-snow {
    border: none !important;
}

.job-markdown-editor .ql-container.ql-snow a {
    color: #2D69F6 !important;
}

.job-markdown-editor .ql-container.ql-snow .ql-editor {
    border-top-right-radius: 0px;
    border-top-left-radius: 0px;
    min-height: 250px !important;
}
</style>